module.exports = __webpack_public_path__ + "img/icon9.68474661.png";